export default "__VITE_ASSET__Be3Ty6Gu__"